import { Box, CardInfo, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import formatCurrency from 'modules/core/lib/formatCurrency'
import { currencyToNumber } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

import DeleteBulkPopover from './DeleteBulkPopover'

interface Props {
  taxonomies: string[]
  supplements: Supplement[]
  timestamp: string
  amount: number
  id: string
  filename: string
  author: string | undefined
}

const SupplementsListItem = ({ listItem }: { listItem: Props }) => {
  const [showToolTip, setShowToolTip] = useToggle(false)
  const [first] = listItem.taxonomies

  const tooltipLabel = listItem.taxonomies.join(', ')

  const taxonomiesLabel =
    listItem.taxonomies.length > 1 ? (
      <Box flexDirection="row" justifyContent="flexStart" gap={'s0'}>
        <Box maxWidth="s96">
          <Tooltip.Dialog
            open={showToolTip}
            toggle={setShowToolTip}
            attachment="top center"
            label={tooltipLabel}
          >
            <Text.Normal ellipsis>{first}</Text.Normal>
          </Tooltip.Dialog>
        </Box>
        <Box>
          <Text.Normal>+{listItem.taxonomies.length - 1}</Text.Normal>
        </Box>
      </Box>
    ) : (
      <Text.Normal>{first}</Text.Normal>
    )

  const header = (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Box flexDirection="column" maxWidth="s300">
        <Text.Normal weight="medium" ellipsis>
          {listItem.filename}
        </Text.Normal>
        <Text.Normal>
          {i18n.t('payroll_bundle.manage_imported_supplements.info_header', {
            timestamp: listItem.timestamp,
            author: listItem.author || '-',
          })}
        </Text.Normal>
      </Box>
      <DeleteBulkPopover bulkImportToDeleteId={listItem.id} filename={listItem.filename} />
    </Box>
  )

  const body = (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Box flexDirection="column" width="s120" maxWidth="s120">
        <Text.Normal weight="medium">
          {i18n.t('payroll_bundle.manage_imported_supplements.amount')}
        </Text.Normal>
        <Text.Normal>{formatCurrency(currencyToNumber(listItem.amount))}</Text.Normal>
      </Box>
      <Box flexDirection="column" width="s120" maxWidth="s120">
        <Text.Normal weight="medium">
          {i18n.t('payroll_bundle.manage_imported_supplements.supplements')}
        </Text.Normal>
        <Text.Normal>{listItem.supplements.length}</Text.Normal>
      </Box>
      <Box flexDirection="column" width="s120" maxWidth="s120">
        <Text.Normal weight="medium">
          {i18n.t('payroll_bundle.manage_imported_supplements.data')}
        </Text.Normal>
        {taxonomiesLabel}
      </Box>
    </Box>
  )

  return (
    <Box key={listItem.id} style={{ marginBottom: '20px' }}>
      <CardInfo header={header}>{body}</CardInfo>
    </Box>
  )
}

export default SupplementsListItem
